import {
  UNASSIGNED,
  UNASSIGNED_FILTER_VALUE,
} from '~/client/src/shared/utils/ZoneLevelLocationConstants'

export const EMPTY_OPTION = UNASSIGNED_FILTER_VALUE

export function normalizeUnassigned(value: string): string {
  return value === UNASSIGNED ? EMPTY_OPTION : value
}

export function emptyIfBlank(value: string | null | undefined): string {
  return value || EMPTY_OPTION
}

export function isEmptyValue(value: unknown): boolean {
  return (
    value == null ||
    (typeof value === 'string' && value.trim() === '') ||
    (typeof value === 'number' && Number.isNaN(value)) ||
    (Array.isArray(value) && value.length === 0)
  )
}
